export default (requestId, response) => {
  console.log('flowResult', 'requestId', requestId, 'response', response);
};
